{
  "createUser": {
    "title": "Creazione di un utente"
  },
  "editUser": {
    "title": "Modificare un utente"
  },
  "selectUserProfileEdit": {
    "title": "Associare un profilo"
  },
  "userGroups": {
    "title": "Associare dei gruppi"
  }
}
